import React, { Component } from 'react';
import { Translate } from "react-localize-redux";
import { connect } from 'react-redux';
import scrollToComponent from 'react-scroll-to-component';
import { Link } from "react-router-dom";

import './Home.scss';

import Separator from '../components/Separator';
import LevelsSVG from '../components/LevelsSVG';
import ShowCarousel from '../components/ShowCarousel';
//import HeaderYoutube from './HeaderYoutube';

import {
  ScrollToHeader,
  ScrollToAbout,
  ScrollToServices,
  ScrollToProjects,
  ScrollToPartners,
  ScrollToGames,
  ScrollToContact,
  ChangeNavbar
} from '../actions';

import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardImgOverlay,
  CardImg,
  CardTitle,
  CardSubtitle,
  CardText,
} from 'reactstrap';

import logoCompleto from '../images/logo_full_gonemadstudios_white.png';

import equipo_pixelart from '../images/equipo_pixelart.png';

import development_icon from '../images/services/Development.png';
import gamification_icon from '../images/services/Gamification.png';
import virtual_environments_icon from '../images/services/VirtualEnvironment.png';
import prototyping_icon from '../images/services/Prototyping.png';
//import vr_icon from '../images/services/VR.png';
import code_icon from '../images/services/Code.png';
//import modeling_icon from '../images/services/Modeling.png';
//import animation_icon from '../images/services/Animation.png';
import sound_icon from '../images/services/Sound.png';

//import nemmus_icon from '../images/projects/nemmus/nemmus.jpg';
import iic_conver_photo_1 from '../images/projects/iic_gamification/gallery/chat_1.jpg';
import iic_conver_photo_2 from '../images/projects/iic_gamification/gallery/chat_2.jpg';
import iic_conver_photo_3 from '../images/projects/iic_gamification/gallery/chat_3.jpg';
import iic_conver_photo_4 from '../images/projects/iic_gamification/gallery/chat_4.jpg';

import iic_robot_photo_1 from '../images/projects/iic_gamification/gallery/robot_1.jpg';
import iic_robot_photo_2 from '../images/projects/iic_gamification/gallery/robot_2.jpg';
import iic_robot_photo_3 from '../images/projects/iic_gamification/gallery/robot_3.jpg';
import iic_robot_photo_4 from '../images/projects/iic_gamification/gallery/robot_4.jpg';

import iic_bomb_photo_1 from '../images/projects/iic_gamification/gallery/bomb_1.jpg';
import iic_bomb_photo_2 from '../images/projects/iic_gamification/gallery/bomb_2.jpg';
import iic_bomb_photo_3 from '../images/projects/iic_gamification/gallery/bomb_3.jpg';

import infohouse_photo_1 from '../images/projects/infohouse/gallery/infohouse_1.jpg';
import infohouse_photo_2 from '../images/projects/infohouse/gallery/infohouse_2.jpg';
import infohouse_photo_3 from '../images/projects/infohouse/gallery/infohouse_3.jpg';
import infohouse_photo_4 from '../images/projects/infohouse/gallery/infohouse_4.jpg';

import laraan_icon from '../images/projects/port_switch/laraan_thumbnail.jpg';
import gunpig_icon from '../images/projects/port_switch/gunpig_thumbnail.jpg';
import kolumno_icon from '../images/projects/port_switch/kolumno_thumbnail.jpg';
import whatcomesafter_icon from '../images/projects/port_switch/whatcomesafter_thumbnail.jpg';

import hatventure_icon from '../images/games/hatventure/hatventure_video.gif';
import hirilun_icon from '../images/games/hirilun/hirilun_logo.png';
import hammertime_icon from '../images/games/hammertime/hammertime.png';

import merge from '../images/partners/merge_blanco_transparente.png';
import univerdidad_valencia from '../images/partners/uv_blanco_transparente.png';
import cutout from '../images/partners/cutout_blanco_transparente.png';
import dacsa from '../images/partners/dacsa_blanco_transparente.png';
import flynns from '../images/partners/flynns_transparente.png';
import iic from '../images/partners/iic_transparente.png';
import klimfort from '../images/partners/klimfort_blanco_transparente.png';
import viralstudios from '../images/partners/viralstudios_blanco2_transparente.png';
import zerouno from '../images/partners/zerouno_games_transparente.png';

class Home extends Component {
  constructor(props) {
    super(props);

    this.props.SetHeaderNavbar(true);

    this.props.SetScrollToHeader(() => scrollToComponent(this.header, { offset: 0, align: 'top', ease: 'in-out-quart', duration: 800}));
    this.props.SetScrollToAbout(() => scrollToComponent(this.about, { offset: 0, align: 'top', ease: 'in-out-quart', duration: 800}));
    this.props.SetScrollToServices(() => scrollToComponent(this.services, { offset: 0, align: 'top', ease: 'in-out-quart', duration: 800}));
    this.props.SetScrollToProjects(() => scrollToComponent(this.projects, { offset: 0, align: 'top', ease: 'in-out-quart', duration: 800}));
    this.props.SetScrollToPartners(() => scrollToComponent(this.partners, { offset: 0, align: 'top', ease: 'in-out-quart', duration: 800}));
    this.props.SetScrollToGames(() => scrollToComponent(this.games, { offset: 0, align: 'top', ease: 'in-out-quart', duration: 800}));
    this.props.SetScrollToContact(() => scrollToComponent(this.contact, { offset: 0, align: 'top', ease: 'in-out-quart', duration: 800}));
  }

  componentDidMount() {
    switch (this.props.scrollTo) {
      case "about":
        scrollToComponent(this.about, { offset: 0, align: 'top', ease: 'in-out-quart', duration: 800});
      break;
      case "services":
        scrollToComponent(this.services, { offset: 0, align: 'top', ease: 'in-out-quart', duration: 800});
      break;
      case "projects":
        scrollToComponent(this.projects, { offset: 0, align: 'top', ease: 'in-out-quart', duration: 800});
      break;
      case "partners":
        scrollToComponent(this.partners, { offset: 0, align: 'top', ease: 'in-out-quart', duration: 800});
      break;
      case "games":
        scrollToComponent(this.games, { offset: 0, align: 'top', ease: 'in-out-quart', duration: 800});
      break;
      case "contact":
        scrollToComponent(this.contact, { offset: 0, align: 'top', ease: 'in-out-quart', duration: 800});
      break;
      default:
        window.scrollTo(0, 0);
      break;
    }
  }

  componentWillUnmount() {
    this.props.SetScrollToHeader(null);
    this.props.SetScrollToAbout(null);
    this.props.SetScrollToServices(null);
    this.props.SetScrollToProjects(null);
    this.props.SetScrollToPartners(null);
    this.props.SetScrollToGames(null);
    this.props.SetScrollToContact(null);
  }

  render() {
    return (
      <div className="content" ref={(section) => { this.header = section; }}>
      <header className="masthead header home text-center text-white d-flex">
        <Container className="my-auto">
          <Row className="header-image">
            <Col lg="8" className="mx-auto">
              <div className="img-fluid glitch">
                <img className="" src={logoCompleto} alt="Gone Mad Studios"/>
              </div>
            </Col>
          </Row>
          <br/><br/>
          <Row className="header-text">
            <Col lg="10" className="mx-auto">
              <Link to="/" className="light" onClick={this.props.scrollToAbout}>
                <i className="fas fa-chevron-down"></i>
              </Link>
            </Col>
          </Row>
        </Container>
      </header>

        <Separator topSeparator={false} />

        <section className="about" ref={(section) => { this.about = section; }}>
          <Container>
            <Row className="title">
              <Col className="mx-auto text-center">
                <h2><Translate id="home.about.title">El estudio</Translate></h2>
              </Col>
            </Row>
            <hr className="hr-line"/>
            <Row>
              <Col lg="8" className="mx-auto text-justify">
                <p><Translate id="home.about.text_1">
                Somos un estudio de mentes locas con mucha creatividad y recursos para hacer realidad tus ideas.<br/><br/>
                Creamos aplicaciones y mundos virtuales para cualquier tipo de proyecto, desde la gamificación de proyectos de formación hasta los simuladores interactivos.
                </Translate></p>
                <img className="img-fluid small" src={equipo_pixelart} alt="Equipo de Gone Mad Studios"/>
                <p><Translate id="home.about.text_2">
                  Gone Mad Studios apuesta por las nuevas tecnologías y nuevas formas de comunicación, fomentando nuevos modelos de gestión empresarial como la flexibilidad,
                  la integración, la responsabilidad entre los trabajadores y la innovación constante.
                </Translate></p>
                <LevelsSVG className="levels" />
              </Col>
            </Row>
          </Container>
        </section>

        <Separator topSeparator={true} />

        <section className="partners" ref={(section) => { this.partners = section; }}>
          <Container>
            <Row className="title">
              <Col className="mx-auto text-center">
                <h2 className="light"><Translate id="home.partners.title">Nuestros compañeros de viaje</Translate></h2>
              </Col>
            </Row>
            <hr className="hr-line"/>
            <Row>
              <Col md="10" className="mx-auto">

                <ul className="list-inline text-center">
                  <li className="list-inline-item logo">
                    <a href="https://www.mergegames.com/" target="_blank" rel="noopener noreferrer">
                      <img src={merge} alt="Merge"/>
                    </a>
                  </li>
                  <li className="list-inline-item logo">
                    <a href="https://www.uv.es/" target="_blank" rel="noopener noreferrer">
                      <img src={univerdidad_valencia} alt="Universidad de Valencia"/>
                    </a>
                  </li>
                  <li className="list-inline-item logo">
                    <a href="https://www.iic.uam.es/" target="_blank" rel="noopener noreferrer">
                      <img src={iic} alt="Instituto de Ingeniería del Conocimiento"/>
                    </a>
                  </li>
                  <li className="list-inline-item logo">
                    <a href="http://www.flynnsarcades.com/" target="_blank" rel="noopener noreferrer">
                      <img src={flynns} alt="Flynns Arcade"/>
                    </a>
                  </li>
                  <li className="list-inline-item logo">
                    <a href="http://www.dacsaproduccions.com/" target="_blank" rel="noopener noreferrer">
                      <img src={dacsa} alt="Dacsa Produccions"/>
                    </a>
                  </li>
                  <li className="list-inline-item logo">
                    <a href="https://zerounogames.com/" target="_blank" rel="noopener noreferrer">
                      <img src={zerouno} alt="ZeroUno Games"/>
                    </a>
                  </li>
                  <li className="list-inline-item logo">
                    <a href="http://www.viralstudios.es/" target="_blank" rel="noopener noreferrer">
                      <img src={viralstudios} alt="Viral Studios"/>
                    </a>
                  </li>
                  <li className="list-inline-item logo">
                    <a href="https://www.cut-out.es/" target="_blank" rel="noopener noreferrer">
                      <img src={cutout} alt="Cut-Out"/>
                    </a>
                  </li>
                  <li className="list-inline-item logo">
                    <a href="https://klimfort.com/" target="_blank" rel="noopener noreferrer">
                      <img src={klimfort} alt="Klimfort Ingeniería e instalaciones"/>
                    </a>
                  </li>
                </ul>
              </Col>
            </Row>
          </Container>
        </section>

        <Separator topSeparator={false} />

        <section className="services" ref={(section) => { this.services = section; }}>
          <Container>
            <Row className="title">
              <Col className="mx-auto text-center">
                <h2><Translate id="home.services.title">Áreas de Trabajo</Translate></h2>
              </Col>
            </Row>
            <hr className="hr-line"/>
            <Row>
              <Col lg="4" className="mx-auto">
                <Card>
                  <CardImg top width="100%" src={development_icon} alt="Card image cap" />
                  <CardBody>
                    <CardTitle><Translate id="home.services.development.title">Desarrollo de Videojuegos</Translate></CardTitle>
                    <i><CardSubtitle><Translate id="home.services.development.subtitle">Nuestra razón de ser.</Translate></CardSubtitle></i>
                    <hr align="left" className="hr-line text-left"/>
                    <CardText>
                      <Translate id="home.services.development.text">
                        El desarrollo de videojuegos es nuestra principal actividad,
                        y aunque desarrollamos nuestros propios proyectos, también hacemos juegos a medida.
                      </Translate>
                    </CardText>
                  </CardBody>
                </Card>
              </Col>
              <Col lg="4" className="mx-auto">
                <Card>
                  <CardImg top width="100%" src={gamification_icon} alt="Card image cap" />
                  <CardBody>
                    <CardTitle><Translate id="home.services.gamification.title">Gamificación</Translate></CardTitle>
                    <i><CardSubtitle><Translate id="home.services.gamification.subtitle">Convertimos en juego todo lo que tocamos.</Translate></CardSubtitle></i>
                    <hr align="left" className="hr-line text-left"/>
                    <CardText>
                      <Translate id="home.services.gamification.text">
                        La mejor forma de aumentar el interés de algo es hacerlo divertido, y nosotros podemos ayudarte a conseguirlo.
                      </Translate>
                    </CardText>
                  </CardBody>
                </Card>
              </Col>
              <Col lg="4" className="mx-auto">
                <Card>
                  <CardImg top width="100%" src={code_icon} alt="Card image cap" />
                  <CardBody>
                    <CardTitle><Translate id="home.services.advergaming.title">Advergaming</Translate></CardTitle>
                    <i><CardSubtitle><Translate id="home.services.advergaming.subtitle">La publicidad con videojuegos</Translate></CardSubtitle></i>
                    <hr align="left" className="hr-line text-left"/>
                    <CardText>
                      <Translate id="home.services.advergaming.text">
                        Captamos la esencia de tu marca y la materializamos en un videojuego, convirtiéndola en una potente herramienta de marketing.
                      </Translate>
                    </CardText>
                  </CardBody>
                </Card>
              </Col>
            </Row>
            <Row>
              <Col lg="4" className="mx-auto">
                <Card>
                  <CardImg top width="100%" src={virtual_environments_icon} alt="Card image cap" />
                  <CardBody>
                    <CardTitle><Translate id="home.services.virtual_environments.title">Entornos Virtuales</Translate></CardTitle>
                    <i><CardSubtitle><Translate id="home.services.virtual_environments.subtitle">Si se puede imaginar, se puede crear.</Translate></CardSubtitle></i>
                    <hr align="left" className="hr-line text-left"/>
                    <CardText>
                      <Translate id="home.services.virtual_environments.text">
                        Maquetas interactivas, inforquitectura, diseño de interiores, visitas virtuales, inmobiliaria...
                        Cualquier cosa que pueda representarse en 3 dimensiones.
                      </Translate>
                    </CardText>
                  </CardBody>
                </Card>
              </Col>
              <Col lg="4" className="mx-auto">
                <Card>
                  <CardImg top width="100%" src={prototyping_icon} alt="Card image cap" />
                  <CardBody>
                    <CardTitle><Translate id="home.services.prototyping.title">Prototipado</Translate></CardTitle>
                    <i><CardSubtitle><Translate id="home.services.prototyping.subtitle">La mejor forma de comprobar la viabilidad de una idea.</Translate></CardSubtitle></i>
                    <hr align="left" className="hr-line text-left"/>
                    <CardText>
                      <Translate id="home.services.prototyping.text">
                        Antes de embarcarte en el desarrollo de un juego, siempre es conveniente comenzar por un prototipo funcional.
                        Nosotros te lo desarrollamos rápidamente.
                      </Translate>
                    </CardText>
                  </CardBody>
                </Card>
              </Col>
              <Col lg="4" className="mx-auto">
                <Card>
                  <CardImg top width="100%" src={sound_icon} alt="Card image cap" />
                  <CardBody>
                    <CardTitle><Translate id="home.services.sound.title">Música y FX</Translate></CardTitle>
                    <i><CardSubtitle>&quot;<Translate id="home.services.sound.subtitle">Sin música, la vida sería un error.</Translate>&quot;</CardSubtitle></i>
                    <hr align="left" className="hr-line text-left"/>
                    <CardText>
                      <Translate id="home.services.sound.text">
                        El sonido es, sin duda, uno de los puntos que más aporta a la calidad de un juego.
                        Hacemos composiciones originales, grabaciones y efectos de sonido.
                      </Translate>
                    </CardText>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </section>

        <Separator topSeparator={true} />

        <section className="projects" ref={(section) => { this.projects = section; }}>
          <Container>
            <Row className="title">
              <Col className="mx-auto text-center">
                <h2 className="light"><Translate id="home.projects.title">Proyectos</Translate></h2>
              </Col>
            </Row>
            <hr className="hr-line"/>
            <Row>
              <Col lg="8" className="mx-auto text-center light">
                <p><Translate id="home.projects.text">
                  Nuestros clientes se han embarcado en aventuras como estas...
                </Translate></p>
              </Col>
            </Row>

            <Row className="project">
              <Col lg="4" className="mx-auto text-justify light">
                <ShowCarousel  mainImage={iic_conver_photo_1} images={[iic_conver_photo_1, iic_conver_photo_2, iic_conver_photo_3, iic_conver_photo_4]}/>
              </Col>
              <Col lg="6" className="mx-auto text-justify light vertical-center-items">
                  <div className="text-container"><div className="left-box" /><Translate id="home.projects.iic_gamification.text_conver">
                    Gamificación de un test de personalidad, convirtiéndolo en un videojuego que simula una situación real de oficina.
                  </Translate></div>

              </Col>
            </Row>
            <Row className="project">
              <Col lg="4" className="mx-auto text-justify light order-sm-12">
                <ShowCarousel  mainImage={iic_robot_photo_1} images={[iic_robot_photo_1, iic_robot_photo_2, iic_robot_photo_3, iic_robot_photo_4]}/>
              </Col>
              <Col lg="6" className="mx-auto text-justify light vertical-center-items light order-sm-1">
                <div className="text-container"><div className="right-box" /><Translate id="home.projects.iic_gamification.text_robot">
                  Transformación de un test psicotécnico sencillo en un entorno 3D interactivo, que cumple y mejora los requisitos del cliente, utilizando técnicas de gamificación.
                </Translate></div>
              </Col>
            </Row>
            <Row className="project">
              <Col lg="4" className="mx-auto text-justify">
                <ShowCarousel  mainImage={iic_bomb_photo_1} images={[iic_bomb_photo_1, iic_bomb_photo_2, iic_bomb_photo_3]}/>
              </Col>
              <Col lg="6" className="mx-auto text-justify light vertical-center-items">
                <div className="text-container"><div className="left-box" /><Translate id="home.projects.iic_gamification.text_bomb">
                  Modernización de una herramienta del cliente, transformándola en un juego de desactivación de bombas, y manteniendo su finalidad original.
                </Translate></div>
              </Col>
            </Row>
            <Row className="project">
              <Col lg="4" className="mx-auto text-justify light order-sm-12">
                <Link to="/infohouse_app">
                  <ShowCarousel  mainImage={infohouse_photo_1} images={[infohouse_photo_1, infohouse_photo_2, infohouse_photo_3, infohouse_photo_4]}/>
                </Link>
              </Col>
              <Col lg="6" className="mx-auto text-justify light vertical-center-items order-sm-1">
                <div className="text-container"><div className="right-box" /><Translate id="home.projects.model">
                  Desarrollo de herramienta para realizar simulaciones de interiores de manera interactiva.
                </Translate></div>
              </Col>
            </Row>
            <Row className="project">
              <Col lg="4" className="mx-auto text-justify light">
                <ShowCarousel  mainImage={whatcomesafter_icon} images={[whatcomesafter_icon, kolumno_icon, gunpig_icon, laraan_icon]}/>
              </Col>
              <Col lg="6" className="mx-auto text-justify light vertical-center-items">
                <div className="text-container"><div className="left-box" /><Translate id="home.projects.laraan">
                  Port a plataforma Nintendo Switch de varios juegos.
                </Translate></div>
              </Col>
            </Row>
          </Container>
        </section>

        <section className="games" ref={(section) => { this.games = section; }}>
          <Container>
            <Row className="title">
              <Col className="mx-auto text-center">
                <h2 className="light"><Translate id="home.games.title">Gone Mad Games</Translate></h2>
              </Col>
            </Row>
            <hr className="hr-line"/>
            <Row>
              <Col lg="8" className="mx-auto text-justify light">
                <p><Translate id="home.games.text">
                  En Gone Mad Studios nos apasionan los videojuegos, así que los hemos convertido en nuestra forma de vida.
                  Además de hacer juegos a medida y aplicaciones para clientes, desarrollamos nuestros propios proyectos.
                  Estos son los juegos en los que hemos trabajado hasta ahora.
                </Translate></p>
              </Col>
            </Row>
            <Row>
              <Col lg="4" className="mx-auto">
                <Link to="/hirilun">
                  <Card>
                    <CardImg top height="100%" src={hirilun_icon} alt="" />
                    <CardImgOverlay>
                      <CardTitle className="light"><Translate id="home.games.hirilun.title">Hirilun</Translate></CardTitle>
                      <CardText className="light"><Translate id="home.games.hirilun.subtitle">Plataformas 3D en primera persona</Translate></CardText>
                    </CardImgOverlay>
                  </Card>
                </Link>
              </Col>
              <Col lg="4" className="mx-auto">
                <Link to="/hatventure">
                  <Card>
                    <CardImg top height="100%" src={hatventure_icon} alt="" />
                    <CardImgOverlay>
                      <CardTitle className="light"><Translate id="home.games.hatventure.title">Hatventure</Translate></CardTitle>
                      <CardText className="light"><Translate id="home.games.hatventure.subtitle">Juego de puzles para Android</Translate></CardText>
                    </CardImgOverlay>
                  </Card>
                </Link>
              </Col>
              <Col lg="4" className="mx-auto">
                <a href="https://gonemadstudios.itch.io/hammertime" target="_blank" rel="noopener noreferrer">
                  <Card>
                    <CardImg top height="100%" src={hammertime_icon} alt="" />
                    <CardImgOverlay>
                      <CardTitle className="light"><Translate id="home.games.hammertime.title">Hammertime!</Translate></CardTitle>
                      <CardText className="light"><Translate id="home.games.hammertime.subtitle">Global Game Jam 2020</Translate></CardText>
                    </CardImgOverlay>
                  </Card>
                </a>
              </Col>
            </Row>
          </Container>
        </section>

        <Separator topSeparator={false} />

        <section className="contact" ref={(section) => { this.contact = section; }}>
          <Container>
            <Row className="title">
              <Col className="mx-auto text-center">
                <h2><Translate id="home.contact.title">¡Pongámonos en contacto!</Translate></h2>
              </Col>
            </Row>
            <hr className="hr-line"/>
            <Row>
              <Col className="text-center">
                <Translate id="home.contact.text">
                  ¿Tienes una idea y te gustaría verla hecha realidad? ¿Necesitas ayuda con alguno de tus proyectos? ¡Escríbenos!
                  Estaremos encantados de estudiar tu caso y asesorarte en lo que necesites.
                </Translate>
              </Col>
            </Row>
            <Row className="contact-info">
              <Col lg="8" className="mx-auto text-center" >
                <i className="fab fa-linkedin-in mr-3" />
                <a href="https://www.linkedin.com/company/gone-mad-studios/" target="_blank" rel="noopener noreferrer">Gone Mad Studios</a>
              </Col>
            </Row>
            <Row className="contact-info">
              <Col lg="8" className="mx-auto text-center" >
                <i className="fas fa-map-marker-alt" />
                  <Translate id="home.contact.location">
                    Valencia, España
                  </Translate>
              </Col>
            </Row>
          </Container>
        </section>

      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    SetHeaderNavbar: (haveHeader) => {dispatch(ChangeNavbar(haveHeader))},
    SetScrollToHeader: (scrollToHeader) => {dispatch(ScrollToHeader(scrollToHeader))},
    SetScrollToAbout: (scrollToAbout) => {dispatch(ScrollToAbout(scrollToAbout))},
    SetScrollToServices: (scrollToServices) => {dispatch(ScrollToServices(scrollToServices))},
    SetScrollToProjects: (scrollToProjects) => {dispatch(ScrollToProjects(scrollToProjects))},
    SetScrollToPartners: (scrollToPartners) => {dispatch(ScrollToPartners(scrollToPartners))},
    SetScrollToGames: (scrollToGames) => {dispatch(ScrollToGames(scrollToGames))},
    SetScrollToContact: (scrollToContact) => {dispatch(ScrollToContact(scrollToContact))}
  }
}

function mapStateToProps(state) {
  return {
    scrollTo: state.ScrollTo.scrollTo,
    scrollToHeader: state.ScrollToHeader.scrollToHeader,
    scrollToAbout: state.ScrollToAbout.scrollToAbout,
    scrollToServices: state.ScrollToServices.scrollToServices,
    scrollToProjects: state.ScrollToProjects.scrollToProjects,
    scrollToPartners: state.ScrollToPartners.scrollToPartners,
    scrollToGames: state.ScrollToGames.scrollToGames,
    scrollToContact: state.ScrollToContact.scrollToContact
  }
}

export default connect (
  mapStateToProps,
  mapDispatchToProps
)(Home);
